import { useNav } from "../context/NavContext";
import { useAuth } from "../context/AuthContext";

export default function RejectedScreen() {
  const { navigate } = useNav();
  const { logout }   = useAuth();

  const handleLogout = () => { logout(); navigate("home"); };
  const handleHelpline = () => alert("Opening helpline…");

  return (
    <div style={{ minHeight: "100dvh", background: "#0a1628", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px 24px 120px", position: "relative", overflow: "hidden" }}>

      {/* Ambient orbs */}
      <div style={{ position: "absolute", top: -60, left: -60, width: 240, height: 240, borderRadius: "50%", background: "#f87171", opacity: 0.08, filter: "blur(70px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: 100, right: -40, width: 180, height: 180, borderRadius: "50%", background: "#fca5a5", opacity: 0.06, filter: "blur(60px)", pointerEvents: "none" }} />

      <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.09)", borderRadius: 28, padding: "40px 28px", maxWidth: 360, width: "100%", textAlign: "center", backdropFilter: "blur(12px)" }}>

        {/* Icon */}
        <div style={{ width: 80, height: 80, borderRadius: "50%", background: "rgba(248,113,113,0.12)", border: "1px solid rgba(248,113,113,0.25)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", fontSize: 36 }}>
          ❌
        </div>

        {/* Badge */}
        <span style={{ display: "inline-block", background: "rgba(248,113,113,0.15)", border: "1px solid rgba(248,113,113,0.3)", borderRadius: 20, padding: "4px 14px", fontSize: 11, color: "#fca5a5", marginBottom: 16, letterSpacing: "0.05em" }}>
          APPLICATION REVIEWED
        </span>

        <h2 style={{ fontSize: 26, fontWeight: 700, color: "#f0f9ff", marginBottom: 8 }}>SORRY!!</h2>
        <p style={{ fontSize: 16, fontWeight: 600, color: "#fca5a5", marginBottom: 12 }}>Application Not Approved</p>
        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", lineHeight: 1.7, marginBottom: 28 }}>
          Your application did not meet our current requirements for credit approval. Please feel free to reapply after <strong style={{ color: "rgba(255,255,255,0.65)" }}>30 days</strong>.
        </p>

        {/* What happens next */}
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: "14px 16px", marginBottom: 28, textAlign: "left" }}>
          <p style={{ fontSize: 12, fontWeight: 600, color: "#7dd3fc", marginBottom: 10 }}>What you can do</p>
          {[
            { icon: "📈", text: "Improve your credit score" },
            { icon: "💰", text: "Increase monthly income proof" },
            { icon: "🔄", text: "Reapply after 30 days" },
          ].map((item) => (
            <div key={item.text} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
              <span style={{ fontSize: 16 }}>{item.icon}</span>
              <span style={{ fontSize: 12, color: "rgba(255,255,255,0.55)" }}>{item.text}</span>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <button onClick={handleHelpline} style={{
          width: "100%", padding: "15px", border: "none", borderRadius: 14,
          background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
          color: "#fff", fontSize: 15, fontWeight: 600, cursor: "pointer",
          boxShadow: "0 4px 20px rgba(14,165,233,0.35)", marginBottom: 12,
        }}>
          Know Possible Reasons
        </button>

        <button onClick={handleLogout} style={{
          width: "100%", padding: "15px", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 14,
          background: "rgba(255,255,255,0.05)", color: "rgba(255,255,255,0.6)",
          fontSize: 14, fontWeight: 500, cursor: "pointer",
        }}>
          Back to Home
        </button>
      </div>
    </div>
  );
}
